export default "__VITE_ASSET__3he7OUxV__"